import { array, bool, number, object, string } from "yup";

export const comparePageValidationObject = {
  price: number()
    .positive("Must be a positive number")
    .integer("Must be an integer")
    .required("Price is required")
    .transform((value, originalValue) =>
      /^\d+$/.test(originalValue) ? parseInt(originalValue) : NaN
    )
    .typeError("Must be a positive integer"),
  zip: number()
    .positive("Must be a 5-digit number")
    .required("Zip code is required")
    .min(500, "Must be a 5-digit number")
    .max(99999, "Must be a 5-digit number")
    .transform((value, originalValue) =>
      /^\d+$/.test(originalValue) ? parseInt(originalValue) : NaN
    )
    .typeError("Must be a 5-digit number"),
  city: string().required("Must provide city"),
  state: string()
    .min(2, "two-digits please")
    .max(2, "Two-digits please")
    .required(),
  county: string().required("Must provide county"),
  street: string().required("Must provide street"),
  isUsCitizen: bool().required(),
  isSelfEmployed: bool().required(),
  isVeteran: bool().required(),
  hasWaivedEscrow: string().required(),
  loanOptions: array().min(1).required(),
  propertyType: string().required(),
  occupancyType: string().required(),
  creditScore: number()
    .typeError("Provided value is invalid")
    .min(620, "Credit score must be 620 or higher")
    .max(850, "Credit score must be 850 or lower")
    .required(),
};

const purchaseComparePageValidationObject = {
  ...comparePageValidationObject,
  downPayment: number()
    .positive("Must be a positive number")
    .integer("Must be an integer")
    .required("Down payment is required")
    .transform((value, originalValue) =>
      /^\d+$/.test(originalValue) ? parseInt(originalValue) : NaN
    )
    .typeError("Must be a positive integer"),
};

const refinanceComparePageValidationObject = {
  ...comparePageValidationObject,
  existingLoanBalance: string().required("Must provide existing balance"),
  takeCashOut: bool().required("Must provide field"),
};

export const purchaseComparePageValidationSchema = object().shape(
  purchaseComparePageValidationObject
);
export const refinanceComparePageValidationSchema = object().shape(
  refinanceComparePageValidationObject
);
